import React, { Children, lazy, Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, UtensilsCrossed, ShoppingCart, Droplets, Sparkles, Sprout, Smartphone, Shirt, Wrench, Tag, Baby, PawPrint, Heart, Stethoscope, Gem, Car, FlaskConical, Crown, Sofa, Sun, Dumbbell, PenTool, Package, Wine, HardHat } from 'lucide-react';
const categories = [{
  title: 'Food & Beverages',
  items: ['Packaged Foods', 'Beverages', 'Dairy Products', 'Snacks & Confectionery'],
  icon: UtensilsCrossed,
  image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'FMCG',
  items: ['Branded Goods', 'Private Label', 'Everyday Essentials', 'Impulse Products'],
  icon: ShoppingCart,
  image: 'https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Household & Cleaning',
  items: ['Cleaning Products', 'Laundry Care', 'Air Fresheners', 'Paper Products'],
  icon: Droplets,
  image: 'https://images.unsplash.com/photo-1563453392212-326f5e854473?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Personal Care & Cosmetics',
  items: ['Skincare', 'Hair Care', 'Oral Care', 'Fragrances'],
  icon: Sparkles,
  image: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Agricultural Products',
  items: ['Fresh Produce', 'Grains & Cereals', 'Spices', 'Commodity Products'],
  icon: Sprout,
  image: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Electronics & Home',
  items: ['Home Appliances', 'Consumer Electronics', 'Kitchen Equipment', 'Smart Home'],
  icon: Smartphone,
  image: 'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Textiles & Apparel',
  items: ['Fashion & Clothing', 'Workwear & Uniforms', 'Home Textiles', 'Footwear & Accessories'],
  icon: Shirt,
  image: 'https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Industrial & Hardware',
  items: ['Tools & Equipment', 'Building Materials', 'Safety Gear', 'Packaging Supplies'],
  icon: Wrench,
  image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Private Label Products',
  items: ['Own-Brand Development', 'White Label Goods', 'Custom Packaging', 'Retail-Ready Products'],
  icon: Tag,
  image: 'https://images.unsplash.com/photo-1607082349566-187342175e2f?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Baby & Childcare',
  items: ['Baby Food & Formula', 'Diapers & Wipes', 'Toys & Games', "Children's Clothing"],
  icon: Baby,
  image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Pet Products',
  items: ['Pet Food', 'Pet Care & Grooming', 'Accessories', 'Veterinary Supplies'],
  icon: PawPrint,
  image: 'https://images.unsplash.com/photo-1601758228041-f3b2795255f1?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Health & Wellness',
  items: ['Vitamins & Supplements', 'Medical Supplies', 'Fitness Equipment', 'Organic & Natural Products'],
  icon: Heart,
  image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Healthcare & Medical Devices',
  items: ['Diagnostic Equipment', 'Surgical Instruments', 'Hospital Supplies', 'Rehabilitation Devices'],
  icon: Stethoscope,
  image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Jewellery & Fine Accessories',
  items: ['Fine Jewellery', 'Fashion Jewellery', 'Watches', 'Luxury Accessories'],
  icon: Gem,
  image: 'https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Automotive Components',
  items: ['Engine Parts', 'Body & Trim', 'Electrical Systems', 'Aftermarket Accessories'],
  icon: Car,
  image: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Specialty Chemicals & Pharma',
  items: ['Active Ingredients', 'Industrial Chemicals', 'Pharmaceutical Raw Materials', 'Laboratory Reagents'],
  icon: FlaskConical,
  image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Premium & Luxury Goods',
  items: ['High-End Cosmetics', 'Designer Products', 'Gourmet Foods', 'Premium Spirits'],
  icon: Crown,
  image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Premium Furniture & Interiors',
  items: ['Designer Furniture', 'Lighting & Fixtures', 'Architectural Hardware', 'Interior Décor'],
  icon: Sofa,
  image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Renewable Energy & Clean Tech',
  items: ['Solar Panels & Systems', 'EV Components', 'Energy Storage', 'Green Building Materials'],
  icon: Sun,
  image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Sports & Outdoor Equipment',
  items: ['Gym & Fitness Gear', 'Camping & Hiking', 'Sporting Goods', 'Outdoor Furniture'],
  icon: Dumbbell,
  image: 'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Stationery & Office Supplies',
  items: ['Writing Instruments', 'Paper & Notebooks', 'Office Equipment', 'School Supplies'],
  icon: PenTool,
  image: 'https://images.unsplash.com/photo-1456735190827-d1262f71b8a3?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Packaging & Logistics Materials',
  items: ['Corrugated Boxes', 'Pallets & Crates', 'Shrink Wrap & Film', 'Labels & Tape'],
  icon: Package,
  image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Wines, Spirits & Tobacco',
  items: ['Fine Wines', 'Premium Spirits', 'Craft Beverages', 'Tobacco Products'],
  icon: Wine,
  image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Construction & Building',
  items: ['Cement & Concrete', 'Steel & Metals', 'Plumbing & Electrical', 'Roofing & Insulation'],
  icon: HardHat,
  image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&q=80&w=800'
}];
export function ProductCategoriesSection() {
  return <section id="products" className="py-24 bg-[#1a2d4a] relative" data-id="element-457">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-458">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-459">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-460">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-461">
              What We Source
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-462">
              Product Categories
            </h2>
            <p className="text-gray-400 text-lg mt-4 max-w-2xl" data-id="element-463">
              We source and supply across virtually every product category —
              from food and FMCG to textiles, electronics, and private label
              goods.
            </p>
          </motion.div>

          <motion.button initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="hidden md:flex items-center gap-2 text-white hover:text-[#d4a853] transition-colors font-medium mt-8 md:mt-0 uppercase tracking-wider text-sm" data-id="element-464">
            View Full Catalog <ArrowRight size={16} data-id="element-465" />
          </motion.button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-466">
          {categories.map((category, index) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="group relative h-[340px] overflow-hidden border border-white/10 cursor-pointer" data-id="element-467">
              {/* Background Image */}
              <div className="absolute inset-0" data-id="element-468">
                <img src={category.image} alt={category.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" onError={e => {
              e.currentTarget.style.display = 'none';
            }} data-id="element-469" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628] via-[#0a1628]/80 to-transparent opacity-90 group-hover:opacity-80 transition-opacity duration-300" data-id="element-470" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end" data-id="element-471">
                <div className="mb-auto opacity-0 group-hover:opacity-100 transform -translate-y-4 group-hover:translate-y-0 transition-all duration-300" data-id="element-472">
                  <div className="w-10 h-10 bg-[#d4a853] flex items-center justify-center text-[#0a1628]" data-id="element-473">
                    <category.icon size={20} data-id="element-474" />
                  </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#d4a853] transition-colors" data-id="element-475">
                  {category.title}
                </h3>

                <div className="space-y-1.5 mb-4 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-476">
                  {category.items.map((item, i) => <div key={i} className="flex items-center gap-2 text-xs text-gray-400" data-id="element-477">
                      <div className="w-1 h-1 bg-[#d4a853] rounded-full flex-shrink-0" data-id="element-478" />
                      {item}
                    </div>)}
                </div>

                <div className="flex items-center gap-2 text-[#d4a853] text-xs font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 delay-100" data-id="element-479">
                  Source This Category <ArrowRight size={14} data-id="element-480" />
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}